export enum IncidencePriority {
    LOW = 1,    // Baja
    MEDIUM = 2, // Media
    HIGH = 3    // Alto
}